import { CircleHelp } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** Compact help icon + tooltip for UiOption.remark. */
export function OptionRemark({ text }: { text: string }) {
  if (!text) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="nodrag nopan inline-flex shrink-0 cursor-help opacity-70 hover:opacity-100"
          tabIndex={0}
          aria-label={text}
        >
          <CircleHelp size={12} className="mr-0" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[260px] text-xs leading-relaxed">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
